<template>
  <div id="placeInfo" v-cloak>
    <!-- Logo -->
    <div class="LogoBorder">
      <img :src="logoUrl" alt="">
      <div>|</div>
      <div>弘成慧考平台</div>
    </div>
    <!-- Info -->
    <div class="Main">
      <div class="userName list">
        <span class="label">姓名</span>
        <span class="label">：</span>
        <p class="text">{{Info.realName}}</p>
      </div>
      <div class="entranceCode list">
        <span class="label">准考证号</span>
        <span class="label">：</span>
        <p class="text">{{Info.entranceCode}}</p>
      </div>
      <div class="placeName list">
        <span class="label">考点名称</span>
        <span class="label">：</span>
        <span class="text">{{Info.placeName}}</span>
      </div>
      <div class="placeAddress list">
        <span class="label">考场地址</span>
        <span class="label">：</span>
        <span class="text">{{Info.placeAddress}}</span>
        <span class="copy" @click="copy('placeAddress')"></span>
        <span class="address" @click="getSite"></span>
      </div>
      <div class="placeLine list">
        <span class="label">路线指引</span>
        <span class="label">：</span>
        <span class="text">{{Info.placeLine}}</span>
        <span class="copy" @click="copy('placeLine')"></span>
      </div>
    </div>
    <!-- Swiper -->
    <div class="swiper-container">
      <div class="swiper-wrapper" v-if="swiperList.length">
          <div class="swiper-slide" v-for="(item,key) in swiperList" :key="key"> 
            <div class="list">
              <span class="label">场次</span>
              <span class="label">：</span>
              <span class="text">{{item.sessionName}}</span>
            </div>
            <div class="list">
              <span class="label">课程</span>
              <span class="label">：</span>
              <span class="text">{{item.courseName}}</span>
            </div>
            <div class="list">
              <span class="label">考试时间</span>
              <span class="label">：</span>
              <span class="text">{{item.examTime}}</span>
            </div>
            <div class="list">
              <span class="label">教室</span>
              <span class="label">：</span>
              <span class="text">{{item.className}}</span>
            </div>
            <div class="list">
              <span class="label">座位号</span>
              <span class="label">：</span>
              <span class="text">{{item.seatNo}}</span>
            </div>
          </div>
      </div>
      <!-- 如果需要分页器 -->
      <div class="swiper-pagination"></div>
    </div>

    <div class="SwiperBottom"></div>
    <van-action-sheet v-model="show" :actions="actions" cancel-text="取消" round @select="onSelect">
    </van-action-sheet>

  </div>
</template>
<script>
  import Swiper from "swiper";
  import "swiper/css/swiper.min.css"
  import { Toast } from "vant";
  export default {
    components: {
      Swiper,
    },
    data() {
      return {
        logoUrl: "",
        Info: [],
        position: [],
        swiperList :[],
        activeIndex: 0,
        show: false,
        actions: [
          // { name: "腾讯地图", keys: "T" },
          { name: "高德地图", keys: "G" },
          // { name: "百度地图", keys: "B" },
        ]
      }
    },
    created() {
      this.getInfo()
      setTimeout(() => {
        this.setSwiper()
      }, 500);
    },
    methods: {
      /**
       * @param { 查询地图 }
       */
      onSelect(value) {
        this.show = false

        let { placeSite } = this.Info
        let latitude = placeSite.split(',')[0]
        let longitude = placeSite.split(',')[1]

        let url
        if (value.keys === 'T') {
          url = `http://apis.map.qq.com/uri/v1/marker?marker=coord:${latitude},${longitude};addr:${this.Info.placeAddress}`
        } else if (value.keys === 'G') {
          url = `http://uri.amap.com/marker?position=${longitude},${latitude}&name=${this.Info.placeAddress}&coordinate=gaode&callnative=1`
        } else if (value.keys === 'B') {
          url = `http://api.map.baidu.com/marker?location=${latitude},${longitude}&title=${this.Info.placeAddress}&content=${this.Info.placeAddress}&output=html`
        }

        window.open(url, "_blank")
      },

      /**
       * @param { Logo, Info }
       */
      getInfo() {
        const { tenant, planId, userId } = this.$route.query
        this.$api.system.getSystemNameFN({ tenant }).then(res=>{
          this.logoUrl = res.data.isUsedLogo == 1 ? res.data.logoUrl ? res.data.logoUrl : require("@/assets/img/customDefault.png") : require("@/assets/img/customDefault.png")
        })
        this.$api.system.getPlaceByExamInfo({tenant, planId, userId }).then(res=>{
          if (res.code) { 
            this.Info = res.data
            this.swiperList = res.data.courses
          }
        })
      },

      /**
       * @param { 复制功能 }
       */
      copy(keys) {
        let createInput = document.createElement("input")
        createInput.value = keys === 'placeAddress' ? this.Info.placeAddress : this.Info.placeLine;
        document.body.appendChild(createInput)
        createInput.select()
        document.execCommand("Copy")
        createInput.style.display = "none"
        Toast(keys === 'placeAddress' ? '考点地址复制成功！' : '路线指引复制成功！')
      },

      /**
       * @param { 获取当前坐标 }
       */
      getSite() {
        this.show = true
      },

      /**
       * @param { Swiper 分页 }
       */
      setSwiper() {
        // 单条数据及以下, 不滑动
        if (this.swiperList.length < 2) return;
        var mySwiper = new Swiper (".swiper-container", {
          loop: true,
          pagination: {
            el: '.swiper-pagination',
          },
        })
        let index = (targetid) => this.swiperList.findIndex(item => item.endFlag === targetid)
        mySwiper.slideTo(index(0)+1)
      },
      
    },

  }
</script>

<style scoped lang="less">
[v-clock] {
  display: none
}
#placeInfo {
  // font-display: block;
  width: 100%;
  height: auto;
  min-height: 100%;
  background: rgba(255, 245, 248, 1);
  background: url("../../assets/img/placeInfo_bg.png") no-repeat;
  background-size: 100% 3.2rem;
  padding: 0 .38rem;
  overflow: hidden;
  box-sizing: border-box;
  .LogoBorder {
    width: 100%;
    height: 1.5rem;
    padding-top: .5rem;
    box-sizing: border-box;
    display: flex;
    margin-bottom: 0.32rem;
    &>img {
      width: auto;
      height: .8rem;
    }
    &>div {
      color: #FFF;
      line-height: .8rem;
      margin: 0 .2rem;
      font-size: .48rem;
      font-display: optional;
      font-family: 'PingFangSC-Regular, PingFang SC';
      font-weight: 500;
    }
    &>div:first-of-type {
      color: rgba(255, 255, 255, 0.3);
    }
  }
  .Main {
    width: 100%;
    background: #FFF;
    border-radius: .2rem;
    padding-top: .5rem;
    font-display: optional;
    font-family: 'PingFangSC-Regular, PingFang SC';
    font-display: block;
    box-shadow: #737780 0 0 .1rem;
    font-size: .38rem;
    .list {
      padding: 0 .4rem;
      box-sizing: border-box;
      padding-bottom: .4rem;
      display: flex;
      .label:first-child {
        color: #737780;
        display: inline-block;
        width: 1.6rem;
        line-height: .5rem;
        text-align: justify;
        text-align-last: justify;
        font-size: .38rem;
      }
      .text {
        word-wrap: break-word;
        word-break: break-all;
        display: inline-block;
        color: #2D2F33;
        line-height: .5rem;
        max-width: 6.5rem;
        height: auto;
      }
      .copy,.address {
        width: 0.64rem;
        height: 0.64rem;
        box-sizing: border-box;
      }
      .copy {
        background:url("../../assets/img/placeInfo_copy.png") no-repeat;
        background-size: 100% 100%;
        margin-right: .15rem;
      }
      .address {
        background:url("../../assets/img/placeInfo_addredd.png") no-repeat;
        background-size: 100% 100%;
      }
    }
    .placeAddress {
      .text {
        width: 4.8rem;
      }
      .copy {
        margin-left: .2rem;
      }
    }
    .placeLine {
      .text {
        width: 5.8rem;
      }
      .copy {
        margin: 0;
      }
    }

  }
  .swiper-container {    
    height: 5.8rem;
    overflow: hidden;
    margin-top: .38rem;
    background: url("../../assets/img/placeInfo_swiper.png") no-repeat;
    border-radius: .2rem;
    box-sizing: border-box;
    box-shadow: #737780 0 0 .2rem;
    font-size: .38rem;
    .swiper-slide{
      width: 100%;
      padding: .5rem 0;
      font-display: optional;
      font-family: 'PingFangSC-Regular, PingFang SC';
      font-display: block;
      .list {
        padding: 0 .4rem;
        box-sizing: border-box;
        padding-bottom: .4rem;
        display: flex;
        .label:first-child {
          color: #737780;
          display: inline-block;
          width: 1.6rem;
          line-height: .5rem;
          text-align: justify;
          text-align-last: justify;
          font-size: .38rem;
        }
        .text {
          word-wrap: break-word;
          word-break: break-all;
          display: inline-block;
          color: #2D2F33;
          line-height: .5rem;
          max-width: 6.2rem;
          min-width: 6.2rem;
          height: auto;
        }
      }
    }
  }
  .SwiperBottom {
    width: 95%;
    background: #FFF;
    height: .20rem;
    margin: .05rem auto;
    border-radius: 0 0 .2rem .2rem;
    box-shadow: 0 .2rem .1rem -0.2rem #737780;
  }

  .Info {
    width: 100%;
    max-width: 960px;
    height: auto;
    max-height: 640px;
    margin: .2rem auto;
    background: #FFF;
    border-radius: 8px;
    box-shadow: #000 0px 0px 10px;
    padding: 24px;
    box-sizing: border-box;
    h1 {
      text-align: center;
      margin-bottom: 24px;
    }
    .item {
      width: 100%;
      height: .6rem;
      display: flex;
      h2 {
        width: 200px;
        text-align: right;
      }
      p {
        line-height: 28px;
        max-width: 5rem;
        font-weight: 700;
      }
    }
  }
}
</style>